module.exports = __webpack_public_path__ + "static/img/illustration-cube-platform.a6a52de1.svg";